import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type { RequeteRecherche } from "@sfs/contracts";
import { rechercheApi } from "./api";

/**
 * Pagination par curseur, pas par page : à un million de lignes, un OFFSET
 * profond relit tout ce qu'il saute. Le curseur ne relit rien.
 */
export function useRecherche(filtres: Partial<RequeteRecherche>) {
  return useInfiniteQuery({
    queryKey: ["recherche", filtres],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam }) => rechercheApi.chercher({ ...filtres, curseur: pageParam }),
    getNextPageParam: derniere => derniere.curseurSuivant
  });
}

export const useFacettes = () =>
  useQuery({ queryKey: ["facettes"], queryFn: rechercheApi.facettes, staleTime: 15 * 60_000 });
